export const groupBy = <T>(ar: T[], f: (t: T) => any): { [name: string]: T[] } => {
    return ar.reduce((r: any, v: T, i, a, k = f(v)) => {
        (r[k] || (r[k] = [])).push(v); 
        
        return r;
    }, {});
}
